export interface ReleaseNote {
  version: string;
  date?: string;
  changes: string[];
}

export interface UpcomingItem {
  title: string;
  detail?: string;
}

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: "v1.3.0",
    changes: [
      "カスタム画面に使用不可カードを確認する機能を追加。対応済みサーバーではスイッチトグルで表示/非表示を切り替え可能",
      "対応済みサーバー（サテライト）: オックス・キャンサー・ダイヤ・オヒュカス・クラウン・ブラキオ・ゴート・キグナス・ハープ・クラブ・アポロン・ファントム・レオ・エンプティー・ウルフ・ジェミニ・リブラ・コンドル・スペード・エース・ブルース・ドラゴン・ラ・ムー",
      "対応済みサーバー（流星）: デルタ・ミュー・カイ・プサイ・オメガ",
    ],
  },
  {
    version: "v1.2.0",
    changes: [
      "日本語の次に多い英語圏からのアクセスを考慮し、英語版を仮実装",
    ],
  },
  {
    version: "v1.1.0",
    changes: [
      "[流星廃人連合氏](https://x.com/ssr_haijin/status/2054109404107350265?s=46)によるカスタム画面仕様の追加",
    ],
  },
  {
    version: "v1.0.0",
    changes: [
      "正式版公開",
      "[MMSF Hub](https://mmsf-hub.nomadblacky.dev/#/sss-viewer)にあった機能をすべて実装",
      "スマホ対応",
    ],
  },
];

export const UPCOMING: UpcomingItem[] = [
  {
    title: "リリースされていない流星に関わるツール群をリリース",
  },
  {
    title:
      "[中長期的] カードの重なりがどの画像にあたるのかをみて、その場で使えないカードを出力する。",
  },
];
